import React from "react";

export default function RadioButtonWithLabel({isChecked,radioButtonValue,label,handleOnChange,selectedLabel}) {
   return  <label>
        <div style={{
            display: "flex",
            alignItems: "center",
        }}>
            <input
                type="radio"
                value={radioButtonValue}
                checked={isChecked??false}
                onChange={(e)=>handleOnChange(e)}
                style={{marginRight: "5px", height: "20px", width: "20px"}}
            />
            <span style={{
                fontWeight: selectedLabel === label ? 600 : 400,
            }}>{label}</span>
        </div>
    </label>
}